import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useExperimentApi } from '../../../store/api/hooks/experimentApiHook'
import toast from 'react-hot-toast'
import Icon from '../../../components/icons'
import CreateConfigMatchingParameters from '../../CreateExperiment/Modal/CreateConfigMatchingParameters'
import { useCommonApi } from '../../../store/api/hooks/commonApiHook'
import { useExperimentSelector } from '../../../store/selectors/experimentSelector'
import { trackEvent } from '../../../_common/functions'

const MatchingParameter = ({ experiment, type }: { experiment: string; type: any }) => {
    const { t } = useTranslation()
    const experimentApi = useExperimentApi()
    const [working, setWorking] = useState(false)
    const commonApi = useCommonApi()
    const experimentData = useExperimentSelector()

    const [matchingParameters, setMatchingParameters] = useState({
        TREAT_OUTLIER: {
            tooltip: t('Detects and adjusts for outliers in the treatment group to avoid skewed results.'),
            value: false,
            type: 'switch',
            label: t('Treat Outlier'),
        },
        OUTLIER_THRESHOLD: {
            tooltip: t('Controls the sensitivity of outlier detection - sets the percentage of POCs (stores) that will be flagged as outliers and removed from analysis (e.g., 0.005 = 0.5% of stores will be marked as outliers).'),
            value: 0.005,
            type: 'numericStepper',
            label: t('Outlier Threshold'),
        },
        ROLLING_MODE: {
            tooltip: t('Enables rolling window-based KPI measurement to capture delayed or sustained impact.'),
            value: false,
            type: 'switch',
            label: t('Rolling Mode'),
        },
    })

    /* DYNA_CLUSTERING: {
            tooltip: t('Dynamically clusters users/entities during analysis to uncover group-specific effects.'),
            value: false,
            type: 'switch',
            label: t('Dyna Clustering'),
        },
        GENERALIZED_SC: {
            tooltip: t(`Builds a data-driven synthetic control group when a natural one isn't reliable`),
            value: false,
            type: 'switch',
            label: t('Generalised SC'),
        }, --- backup*/

    const parseValue = (value: any) => {
        if (value === '1') return true
        if (value === '0') return false
        return value
    }

    const getAdvanceConfigOption = () => {
        const parameterKeys = Object.keys(matchingParameters) as (keyof typeof matchingParameters)[]

        commonApi.getAdvanceConfigOption(
            { sort_by: 'attribute_key', page: 1, per_page: 10, step: 'measurement' },
            (resp: any) => {
                for (const item of resp.data?.result || []) {
                    const parsedValue = parseValue(item?.value)

                    if (parameterKeys.includes(item.attribute_key as (typeof parameterKeys)[number])) {
                        setMatchingParameters((prev) => ({
                            ...prev,
                            [item.attribute_key]: {
                                ...prev[item.attribute_key as keyof typeof prev],
                                value: parsedValue,
                            },
                        }))
                    }
                }
            },
            (error) => {
                toast.error(error?.message)
            },
        )
    }

    const createConfigMatchingParametersRef = useRef<HTMLDialogElement>(null)

    const openModal = () => {
        trackEvent('measurement_advance_config_opened', { experiment_literal: experiment })
        createConfigMatchingParametersRef.current?.showModal()
    }

    const updateToggleValue = () => {
        trackEvent('measurement_advance_config_saved', { experiment_literal: experiment })
        const payload: any = {
            step: 5,
            is_draft: true,
            literal: experiment,
            // measurement_config: matchingParameters,
            measurement_config: (Object.keys(matchingParameters) as (keyof typeof matchingParameters)[]).reduce((a: any, c: string) => {
                a = {
                    ...a,
                    [c]: matchingParameters[c as keyof typeof matchingParameters]['value'],
                }
                return a
            }, {}),
        }
        setWorking(true)
        experimentApi.updateExperiment(
            payload,
            (resp: any) => {
                createConfigMatchingParametersRef.current?.close()
                setWorking(false)
            },
            (error: any) => {
                setWorking(false)
                toast.error(error?.message)
            },
        )
    }
    useEffect(() => {
        getAdvanceConfigOption()
    }, [])

    return (
        <>
            {experimentData?.experiment_metadatas?.metrices?.[0]?.kpi_literal !== 'kpi_004' &&
                experimentData?.experiment_metadatas?.metrices?.[0]?.kpi_literal !== 'kpi_005' &&
                experimentData?.experiment_metadatas?.metrices?.[0]?.kpi_literal !== 'kpi_006' && (
                    <button type="button" onClick={openModal} className="flex items-center gap-2 text-right cursor-pointer bg-transparent border-none p-0" style={{ background: 'none', border: 'none' }} aria-label={t('Open advanced configurations')}>
                        <Icon name="settings" size="1rem" color="#000" />
                        <span
                            className="mb-0 font-medium"
                            style={{
                                fontFamily: 'Poppins, sans-serif',
                                fontSize: '16px',
                                lineHeight: '100%',
                                letterSpacing: '0%',
                                verticalAlign: 'middle',
                            }}
                        >
                            {t('Advance Configurations')}
                        </span>
                    </button>
                )}

            <CreateConfigMatchingParameters _ref={createConfigMatchingParametersRef} type={type} matchingParameters={matchingParameters} setMatchingParameters={setMatchingParameters} handleContinue={updateToggleValue} disabled={working} />
        </>
    )
}

export default MatchingParameter
